import NormalBookingComponent from '../components/Booking/NormalBooking';
import HistoryComponent from '../components/Booking/History';
import BookingResultComponent from '../components/Booking/BookingResult';
import UsageQuery from '../components/Booking/UsageQuery';
import ReviewComponent from '../components/Review';
import SettingComponent from '../components/Setting/';
import ManageComponent from '../components/Manage/';
import ForbiddenComponent from '../components/Exceptions/403';
import NoFoundComponent from '../components/Exceptions/404';
import ErrorComponent from '../components/Exceptions/500';
import LoginComponent from '../components/Login';
import NewsComponent from '../components/News';
import VueRouter from 'vue-router'
import store from '../store';
import {getAuth, setAuth} from '../services/auth';


export const routeDefs = [
    {
        path: '/',
        redirect: '/news',
    },
    {
        title: '公告',
        show: true,
        claims: ['user'],
        path: '/news',
        name: 'news',
        exact: true,
        component: NewsComponent
    },
    {
        title: '借用',
        show: true,
        claims: ['user'],
        path: '/booking',
        name: 'booking',
        redirect: '/booking/normal',
        exact: true,
    },
    {
        title: '空教室查詢',
        show: true,
        claims: ['user'],
        path: '/booking/usage',
        inSubMenu: true,
        parent: 'booking',
        component: UsageQuery,
        name: 'usage',
        exact: true,
        checkOpen: true
    },
    {
        title: '國秀樓教室借用',
        show: true,
        inSubMenu: true,
        parent: 'booking',
        claims: ['user'],
        path: '/booking/normal',
        component: NormalBookingComponent,
        name: 'booking/normal',
        exact: true,
        checkOpen: true
    },
    {
        title: '申請紀錄',
        show: true,
        claims: ['user'],
        path: '/booking/history',
        inSubMenu: true,
        parent: 'booking',
        component: HistoryComponent,
        name: 'history',
        exact: true
    },
    {
        claims: ['user'],
        path: '/bookingRst',
        name: 'bookingRst',
        exact: true,
        component: BookingResultComponent
    },
    {
        title: '申請審查',
        show: true,
        claims: ['admin'],
        path: '/review',
        component: ReviewComponent,
        name: 'review',
        exact: true
    },
    {
        title: '管理',
        show: true,
        claims: ['super', 'admin'],
        path: '/manage',
        component: ManageComponent,
        name: 'manage',
        exact: true
    },
    {
        title: '系統設定',
        show: true,
        claims: ['super', 'admin'],
        path: '/setting',
        component: SettingComponent,
        name: 'setting',
        exact: true
    },
    {
        claims: [],
        path: '/login',
        component: LoginComponent,
        name: 'login'
    },
    {
        claims: [],
        path: '/403',
        component: ForbiddenComponent,
        name: 'forbidden'
    },
    {
        claims: [],
        path: '/404',
        component: NoFoundComponent,
        name: 'noFound'
    },
    {
        claims: [],
        path: '/500',
        component: ErrorComponent,
        name: 'error'
    },
    {
        path: '/sso',
        name: 'sso'
    },
    {
        path: '*'
    }
];

const router = new VueRouter({
    mode: 'history',
    routes: routeDefs,
    base: process.env.VUE_APP_IS_STAGING === 'true' ? '/gxbooking/' : '/'
});


router.beforeEach((to, from, next) => {
    const {path} = to.matched[0];
    if (path === '*') {
        next({name: 'noFound'});
    } else if (to.name === 'sso') {
        const {t} = to.query;
        if (t) {
            try {
                setAuth(window.atob(t));
                next('/');
            } catch {
                next({name: 'forbidden'});
            }
        } else {
            next({name: 'forbidden'});
        }
    } else {
        const {name} = to;
        const {claims} = getAuth();
        const authenticated = claims.length > 0;
        if (name === 'login') {
            if (authenticated) {
                next('/');
            } else {
                next();
            }
        } else {
            const def = routeDefs.find(r => r.name === name);

            if (authenticated || !def || def.claims.length <= 0) {
                if (def && def.claims.length > 0) {
                    //代表這個路徑允許這個登入者
                    if (def.claims.some(c => claims.some(cc => cc === c))) {
                        next();
                    } else {
                        store.commit('resetLoading');
                        //未授權
                        next({name: 'forbidden'})
                    }
                } else {
                    //不需要驗證的位址
                    if (def.name === 'forbidden' || def.name === 'error' || def.name === 'noFound') {
                        store.commit('resetLoading');
                    }
                    next();
                }

            } else {
                next({name: 'login', query: {redirect: name}});
            }
        }

    }

});

export default router;